import { CheckboxUI } from '../Interface';
import { useFormikContext } from 'formik';

const RoleExcludedItemGroupLinks = ({ disabled }) => {
  const { values, setFieldValue } = useFormikContext();

  const updateRoleExcludedItemGroup = (roleId, isChecked) => {
    const updatedLinks = values?.roleExcludedItemGroup?.map((link) =>
      link.roleId === roleId ? { ...link, checked: isChecked } : link
    );
    setFieldValue('roleExcludedItemGroup', updatedLinks);
  };

  return (
    <div>
      {values?.roleExcludedItemGroup?.map((groupLink) => (
        <div key={groupLink.roleId}>
          <CheckboxUI
            sx={{ margin: 0, padding: '0.2rem' }}
            disabled={disabled}
            onChange={(e) => updateRoleExcludedItemGroup(groupLink.roleId, e.target.checked)}
            checked={groupLink.checked || false}
          />
          {groupLink.roleName}
        </div>
      ))}
    </div>
  );
};

export default RoleExcludedItemGroupLinks;
